/**
*
*   Ideas Section
*       - Idea Block Section
*
**/
'use client';

import Image from '@/components/image';
import { gsap } from 'gsap';
import { useGSAP } from '@gsap/react';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
import { useState, useRef, Fragment } from 'react';
import { useLocale } from 'next-intl';

//Load Module
gsap.registerPlugin(useGSAP);
gsap.registerPlugin(ScrollTrigger);

//Build the Element
export default function Ideas({ product, ...props }){

	const ref = useRef();

	const locale = useLocale();

	const [ open , setOpen ] = useState( false );

	/*
	//On Mount
	useGSAP(() => {

		//Skip if it hasn't loaded
		if( !ref.current ) return;

		//Prepare the MatchMedia
		let mm = gsap.matchMedia();

		//Set Variables
		const $section  = ref.current;
		const $title    = $section.querySelectorAll('h2 > *');
		const $content  = $section.querySelectorAll('dt,dd');

		//
		mm.add('(min-width: 751px)', context => {

			//Create Timeline
			let timeline = gsap.timeline({
				scrollTrigger: {
					trigger:                $section,
					invalidateOnRefresh:    true,
					scrub:                  true,
					pin:                    false,
					markers:                false,
					start:                  '-40% left',
					end:                    '50% left',
				},
			});

			//Title
			$title.forEach(
				$part => timeline.fromTo( $part, { opacity:0, yPercent:15 },{ opacity:1, yPercent:0 })
			)

			//Image Animation
			$content.forEach(
				$part => timeline.fromTo( $part , { opacity:0, yPercent:15 },{ opacity:1, yPercent:0 })
			);

		});

		//
		mm.add('(max-width: 750px)', context => {

			//Create Timeline
			let timeline = gsap.timeline({
				scrollTrigger: {
					trigger:                $section,
					invalidateOnRefresh:    true,
					scrub:                  true,
					pin:                    false,
					markers:                false,
					once:                   true,
					start:                  '-100% left',
					end:                    '50% left',
				},
			});

			//Title
			$title.forEach(
				$part => timeline.fromTo( $part, { opacity:0, yPercent:15 },{ opacity:1, yPercent:0 })
			)

			//Image Animation
			$content.forEach(
				$part => timeline.fromTo( $part , { opacity:0, yPercent:15 },{ opacity:1, yPercent:0 })
			);

		});

	}, { scope: ref.current });
	*/

	//Return nil
	if( !product.blocks.scenarios.list?.[0]?.title?.[ locale ] ) return;

	//Return
	return (
		<section id="ideas" ref={ ref }>
			<header>
				<h2 dangerouslySetInnerHTML={{
					__html: product.blocks.scenarios.header?.[ locale ]
				}} />
			</header>
			<dl>
				{ product.blocks.scenarios.list.length > 0 && product.blocks.scenarios.list.map( ( scenario , i ) => (
					<Fragment key={i}>
						<dt onClick={ (e)=> {
							if( i > 0 ) e.currentTarget.classList.toggle('open');
						}}>
							{ scenario.category?.[ locale ] }
							<span>
								<span></span>
								<span></span>
							</span>
						</dt>
						<dd>
							<Image src={ scenario.media?.[0]?.src } alt="" width="388" height="215" />
							<h3>{ scenario.title?.[ locale ] }</h3>
							<p>{ scenario.content?.[ locale ] }</p>
						</dd>
					</Fragment>
				))}
			</dl>
		</section>
	);

}